import { Theme, useTheme } from "@mui/material/styles";

import { HOME_TOKENS } from "./tokens";

/** `"success.main"` -> `theme.palette.success.main`. Mesma convenção de caminho usada em `HOME_TOKENS.state`. */
function resolveThemeColor(theme: Theme, path: string): string {
  return path.split(".").reduce<unknown>((value, key) => (value as Record<string, unknown>)?.[key], theme.palette) as string;
}

interface IStateIconProps {
  /** `CONDUCCO` não passa por aqui — a régua vermelha já carrega o sentido, ícone seria redundante. */
  state: "EM_DIA" | "PARADO";
}

/**
 * Dois SVGs inline a 14px, em `currentColor` — sem depender de mais uma lib
 * de ícone além de `@mui/icons-material`, que já está no app. Inline dá
 * controle exato do traço nesse tamanho pequeno, que é o pedido do dispatch
 * do T8 (spec da tela inicial v2.1).
 *
 * A cor não fica aqui dentro: quem herda `success.main`/`text.secondary` é o
 * `Box` pai via `sx.color`, e o SVG só usa `currentColor` — assim o ícone não
 * duplica o eixo de cor que já vive em `HOME_TOKENS.state`.
 */
export function StateIcon({ state }: IStateIconProps) {
  const theme = useTheme();
  const token = HOME_TOKENS.state[state];
  const label = state === "EM_DIA" ? "Em dia" : "Parado";
  const color = resolveThemeColor(theme, token.color);

  return (
    <svg
      role="img"
      aria-label={label}
      width={HOME_TOKENS.row.iconSize}
      height={HOME_TOKENS.row.iconSize}
      viewBox="0 0 14 14"
      fill="none"
      style={{ color, flexShrink: 0 }}
    >
      <circle cx="7" cy="7" r="6" stroke="currentColor" strokeWidth="1.4" />
      {state === "EM_DIA" ? (
        <path
          d="M4.2 7.2 L6.1 9.1 L9.8 5"
          stroke="currentColor"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      ) : (
        <>
          <line x1="5.4" y1="4.3" x2="5.4" y2="9.7" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
          <line x1="8.6" y1="4.3" x2="8.6" y2="9.7" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
        </>
      )}
    </svg>
  );
}
